export enum GlobalConfigs {
  SYS_API_VERSION = "/sys-v100002",
  OTHER_API_VERSION = "/other-v100002",
  HOUSE_API_VERSION = "/house-v100002",
  FINANCE_API_VERSION = "/finance-v100002",
  REPORT_API_VERSION = "/report-v100002"
}
